/**
 * There's many ways to specify an href to make the whole block clickable using that href:
 * 1. Pass in a direct "href" prop
 * 2. In "components" prop (for CTA button/link) if there's a link it will pick up that link
 * 3. In "blurb" prop (wysiwyg content) if there's a link it will pick up that link
 */
import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRadium } from "higher-order-components"
import gtmHandler from "AtomicUtils/gtmHandler"
import componentParser from "AtomicUtils/componentParser"
import { Image } from 'AtomicContainers'
import { WINDOW } from "AtomicUtils/environment"
import bowser from "bowser"
import { Interactive, H6, Space, Content, Card } from "AtomicComponents";

/** Render an image tout block */
class ImageToutBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      href: props.href
    }
  }
  componentDidMount() {
    const { blurb, components } = this.props
    // If there's a link in wysiwyg, get the first link and put it in state
    if (Array.isArray(components) && components[0].props) {
      this.setState({ href: components[0].props.href })
    } else if (blurb && blurb.includes("<a href=")) {
      const matchHref = blurb.match(/<a href="(.*?)"/)
      this.setState({ href: matchHref[1] })
    }
  }
  handleClick = () => {
    const { gtm } = this.props
    // Dispatch GTM action
    if (gtm && gtm.category) {
      // If not, use CMS gtm event
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action
      })
    }

    // Proceed with the link
    const { href } = this.state
    if (href) {
      if (bowser.ios) {
        setTimeout(() => {
          WINDOW.location.href = href
        }, 300)
      } else {
        WINDOW.location.href = href
      }
    }
  }

  render() {
    const {
      blurb, outline = false, preHeading, heading, horizontalLine
    } = this.props
    const { href } = this.state
    const clickable = !!href
    return (
      <div
        style={[styles.base(clickable), outline && styles.border]}
        onClick={() => this.handleClick()}>
        <div style={styles.img}>
          <Image src={this.props.imageSrc} alt={this.props.imageAlt} />
        </div>
        <div style={styles.content}>
          {
            preHeading &&
            <Interactive>{preHeading}</Interactive>
          }
          {preHeading && <Space />}
          {
            heading &&
            <div
              style={{
                minHeight: '42px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <H6 withDetails>{heading}</H6>
            </div>
          }
          {blurb && (
            <div
              style={
                horizontalLine && {
                  borderTop: "1px solid #d5d5d5",
                  marginTop: "1em",
                  padding: "1em 0"
                }
              }>
              <Content xmlString={blurb} />
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            {componentParser(this.props.components)}
          </div>
        </div>
      </div>
    )
  }
}

export default withRadium()(ImageToutBlock)

ImageToutBlock.propTypes = {
  preHeading: PropTypes.string,
  heading: PropTypes.string,
  blurb: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  gtm: PropTypes.object,
  horizontalLine: PropTypes.bool,
  outline: PropTypes.bool,
  gtmEvent: PropTypes.func,
  components: PropTypes.array
}

const styles = {
  border: {
    border: "1px solid #d5d5d5",
    background: "#fff"
  },
  base: clickable => ({
    margin: "0px 0px 1em 0px",
    height: "100%",
    width: "100%",
    cursor: clickable && "pointer"
  }),
  content: {
    padding: "1em",
    textAlign: "center"
  },
  img: {
    marginBottom: "1em",
    width: "100%"
  }
}



// WEBPACK FOOTER //
// ./src/containers/image-tout-block/index.jsx